import React from 'react'
import ProtectionPage from '../protection'

const ProtectionPageFr = () => {
    return <ProtectionPage languageCode="en" />
}

export default ProtectionPageFr
